import voteFingers0 from '../../../assets/icons/voteFingers-0.svg';
import voteFingers1 from '../../../assets/icons/voteFingers-1.svg';
import voteFingers2 from '../../../assets/icons/voteFingers-2.svg';
import voteFingers3 from '../../../assets/icons/voteFingers-3.svg';
import voteFingers4 from '../../../assets/icons/voteFingers-4.svg';
import voteFingers5 from '../../../assets/icons/voteFingers-5.svg';
import { svgToIcon } from '../../../utils/svg';

export default [
  voteFingers0,
  voteFingers1,
  voteFingers2,
  voteFingers3,
  voteFingers4,
  voteFingers5,
].map(svg => svgToIcon(svg));
